module.exports = __webpack_public_path__ + "img/weddings_28_V.7184d4a6.webp";